import { motion } from "framer-motion";
import { Counter, Reveal } from "@/lib/anim";

const STATS = [
  { to: 120, suffix: "+", label: "Projects shipped", accent: "bg-teal" },
  { to: 40, suffix: "k+", label: "Hours saved by automations", accent: "bg-cobalt" },
  { to: 35, suffix: "+", label: "Client sites live", accent: "bg-violet" },
  { to: 100, suffix: "%", label: "Custom-built, never templated", accent: "bg-magenta" },
];

export const StatsBand = () => {
  return (
    <section className="relative py-16 md:py-24" data-testid="results-band">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-3xl border border-white/10 overflow-hidden bg-gradient-to-r from-teal/10 via-cobalt/10 to-magenta/10 backdrop-blur-sm p-10 md:p-14"
        >
          {/* glow accents */}
          <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-teal/15 blur-3xl pointer-events-none" />
          <div className="absolute -right-20 -bottom-20 h-64 w-64 rounded-full bg-magenta/15 blur-3xl pointer-events-none" />

          <div className="relative">
            <Reveal>
              <span className="text-xs uppercase tracking-[0.25em] text-teal/80">
                The results
              </span>
            </Reveal>
            <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 md:divide-x md:divide-white/10">
              {STATS.map((s, i) => (
                <div key={s.label} className={`md:px-8 ${i === 0 ? "md:pl-0" : ""}`} data-testid={`result-${i}`}>
                  <div className="flex items-center gap-2">
                    <span className={`h-2 w-2 rounded-full ${s.accent}`} />
                    <Counter
                      to={s.to}
                      suffix={s.suffix}
                      className="font-heading text-5xl md:text-6xl font-extrabold gradient-text leading-none"
                    />
                  </div>
                  <div className="mt-3 text-sm text-white/60 leading-snug max-w-[12rem]">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
